<script lang="ts">
    import RewardsActionButton from "@apps/rewards/components/Buttons/RewardsActionButton.svelte";
    import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import type LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
    import type { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    //Props
    export let locationController: LocationControllerInterface;
    export let namespace: RewardsTranslationNamespaces;
    export let urlsBuilder: URLsBuilder;
</script>

<div class="gw-rd-ways-to-earn-page-widget-button-group">
    <RewardsActionButton
        variant="secondary"
        on:click={() =>
            locationController.goTo(urlsBuilder.createRegisterUrl())}
    >
        <Text component="span" variant="base" weight="semibold">
            <T {namespace} translationKey="sign_up_btn_label" />
        </Text>
    </RewardsActionButton>
    <RewardsActionButton
        variant="link"
        on:click={() => locationController.goTo(urlsBuilder.createLoginUrl())}
    >
        <Text component="span" variant="base" weight="semibold">
            <T {namespace} translationKey="log_in_btn_label" />
        </Text>
    </RewardsActionButton>
</div>

<style lang="postcss">
    .gw-rd-ways-to-earn-page-widget-button-group {
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: center;
        gap: var(--gw-rd-space-12);

        :global(.gw-btn.gw-rd-action-btn) {
            font-size: 14px;
        }
    }
</style>
